import _ from 'lodash';

const GeneralHelper = {
	/**
	 * Check if the value is a valid email
	 * @param {String} email
	 * @returns {Boolean}
	 */
	isEmailValid(email) {
		const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	},

	/**
	 * Convert a query from string to javacript object
	 * @param {String} queryString
	 * @returns {Object}
	 */
	queryStringToObject(queryString) {
		if (!queryString || !_.isString(queryString)) {
			return {};
		}
		if (queryString.indexOf('?') === 0) {
			queryString = queryString.substring(1);
		}
		try {
			return JSON.parse(
				'{"' +
				decodeURI(queryString)
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
			);
		} catch (e) { }
		return {};
	},

	/**
	 *
	 * @param {object} obj
	 * @returns {string}
	 */
	objectToQueryString(obj) {
		const keyValuePairs = [];

		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				const value = obj[key];
				const encodedKey = encodeURIComponent(key);
				const encodedValue = encodeURIComponent(value);
				keyValuePairs.push(`${encodedKey}=${encodedValue}`);
			}
		}

		return keyValuePairs.join('&');
	},

	/**
	 *
	 * @returns {String}
	 */
	getImageBasePath() {
		const path = process.env.NODE_ENV === 'local' ? '' : '/admin';
		return path;
	},

	/**
	 *
	 * @returns {Object}
	 */
	getParamsFromUrl() {
		// Create a new URLSearchParams object from the given URL.
		const searchParams = new URLSearchParams(window.location.search);

		// Create an object to store the query string parameters.
		const params = {};

		// Iterate over the query string parameters and add them to the object.
		for (const [key, value] of searchParams) {
			params[key] = value;
		}

		// Return the object of query string parameters.
		return params;
	},

	countWords(str) {
		const words = str.trim().split(/\s+/);
		return words.length;
	},
	truncateFileName(text, limit, type) {
		if (text.length <= limit) {
			return text;
		}

		const formattedText = text.substring(0, text.length - 4);
		const midpoint = Math.floor(limit / 2);
		const start = formattedText.substring(0, midpoint);
		const end = formattedText.substring(text.length - midpoint);

		return start + '...' + end + `.${type}`;
	},
	truncateLongText(text, limit) {
		if (text.length <= limit) {
			return text;
		}

		const formattedText = text.substring(0, limit);

		return formattedText + '...';
	},
	handleCapitalization(ref, name) {
		const value = ref.current.getFieldValue(name);
		const newValue = {};
		// Set new value in object
		newValue[name] = value.toUpperCase();
		ref.current.setFieldsValue(newValue);
	},
	sanitizeInput(value) {
		if (!value) return '';
		const disallowedChars = ['=', '+', '-', '@', '\t'];
		let sanitized = value;
		disallowedChars.forEach(char => {
			sanitized = sanitized.split(char).join('');
		});
		return sanitized;
	},
	// New function to check disallowed characters
	checkDisallowedCharacters(value) {
		if (!value) return false;
		// const disallowedChars = ['=', '+', '-', '@', '\t'];
		const disallowedChars = ['\t'];
		return disallowedChars.some(char => value.includes(char));
	},
	// Add preventDisallowedKeys for keyDown events
	preventDisallowedKeys(e) {
		// if (['=', '+', '-', '@', 'Tab'].includes(e.key)) {
		// 	e.preventDefault();
		// }
		if (['Tab'].includes(e.key)) {
			e.preventDefault();
		}
	}
};

export default GeneralHelper;
